import Dexie from 'dexie';

export const db = new Dexie('dolmio-offline');

// MUST match the API_CACHE cacheName in public/sw.js.
export const API_CACHE = 'dolmio-api-v1';

// v1 schema.
// - appointments/reports/workWeeks: server truth from pulls, keyed by server id.
// - outbox: pending write jobs (auto seq = FIFO order).
// - meta: small key/value store (last sync timestamps, etc.).
db.version(1).stores({
  appointments: 'id, start_time',
  reports: 'id, event_id',
  workWeeks: 'id, week_start',
  outbox: '++seq, entity, clientUuid, status',
  meta: 'key',
});

export async function setMeta(key, value) {
  await db.meta.put({ key, value });
}

export async function getMeta(key) {
  const row = await db.meta.get(key);
  return row ? row.value : undefined;
}

// Purges all offline data and pending outbox jobs. Must be called on logout
// so a shared browser/PWA never carries a previous user's cached appointments
// (incl. client contact data) or pending outbox jobs into the next login —
// otherwise a queued job could be flushed under the new user's token.
export async function clearOfflineData() {
  await Promise.all([
    db.appointments.clear(),
    db.reports.clear(),
    db.workWeeks.clear(),
    db.outbox.clear(),
    db.meta.clear(),
  ]);
  if (typeof caches !== 'undefined') {
    try {
      const names = await caches.keys();
      await Promise.all(
        names.filter((n) => n.startsWith('dolmio-api')).map((n) => caches.delete(n))
      );
    } catch (_) { /* cache purge is best-effort */ }
  }
}
